var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95864 19.5703C10.0021 19.8055 10.026 20.0375 10.026 20.2618C10.026 21.387 9.11382 22.2992 7.9886 22.2992C6.86338 22.2992 5.95117 21.387 5.95117 20.2618C5.95117 20.0375 5.97514 19.8055 6.01856 19.5703",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9888 3.26276C8.75172 3.26276 9.37019 2.6443 9.37019 1.88138C9.37019 1.11847 8.75172 0.5 7.9888 0.5C7.22589 0.5 6.60742 1.11847 6.60742 1.88138C6.60742 2.6443 7.22589 3.26276 7.9888 3.26276Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2155 19.5682H0.526367V16.8248L1.87862 14.8349L1.88315 10.2969C1.88315 8.61089 2.56651 7.08451 3.67138 5.97964C4.77625 4.87477 6.30263 4.19141 7.98865 4.19141C11.3607 4.19141 14.0942 6.92486 14.0942 10.2969V12.1349",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.64729C1.32831 4.31859 2.50071 3.22494 3.89109 2.49219",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.478 5.64724C14.6497 4.31855 13.4773 3.22494 12.0869 2.49219",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9849 22.299H17.667L17.9015 21.1796C18.0878 20.2897 19.0063 19.7593 19.8702 20.0427L20.9574 20.3993L22.2985 18.0765L21.4462 17.3135C20.7689 16.7071 20.7689 15.6466 21.4462 15.0402L22.2985 14.2771L20.9574 11.9544L19.8705 12.3109C19.0066 12.5943 18.0882 12.064 17.9017 11.1743L17.667 10.0547H14.9849L14.7502 11.1745C14.5636 12.0644 13.6451 12.5946 12.7812 12.3111L11.6946 11.9544L10.3535 14.2771L11.2059 15.04C11.8835 15.6464 11.8835 16.7072 11.2059 17.3136L10.3535 18.0765L11.6946 20.3993L12.7814 20.0425C13.6454 19.7589 14.5641 20.2893 14.7505 21.1794L14.9849 22.299Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3267 17.9228C17.2913 17.9228 18.0732 17.1409 18.0732 16.1763C18.0732 15.2117 17.2913 14.4297 16.3267 14.4297C15.362 14.4297 14.5801 15.2117 14.5801 16.1763C14.5801 17.1409 15.362 17.9228 16.3267 17.9228Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.20ee6522ce73b7152b360a8b6758e2ec.svg";
export { ForwardRef as ReactComponent };